/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InventoryResourceUtilizationSeries {
    getFixupPrototypeFunction() { return InventoryResourceUtilizationSeries.fixupPrototype; }

    static newInstance(model: Partial<InventoryResourceUtilizationSeries>): InventoryResourceUtilizationSeries {
        let obj = Object.assign(new InventoryResourceUtilizationSeries(), model);
        InventoryResourceUtilizationSeries.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InventoryResourceUtilizationSeries>): InventoryResourceUtilizationSeries {
        if (!model) return null;
        return InventoryResourceUtilizationSeries.newInstance(<InventoryResourceUtilizationSeries> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InventoryResourceUtilizationSeries) {
        if (!obj) return;

        models.InventoryResourceUtilizationSeries.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InventoryResourceUtilizationSeries): boolean {
        Object.setPrototypeOf(obj, InventoryResourceUtilizationSeries.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Metric name as the cloud reports it, for example CPUUtilization
     */
    metric_name: string;

    /**
     * Unit the cloud reports the metric in, for example Percent or Bytes
     */
    unit: string;

    /**
     * Enhanced monitoring group, for example cpuUtilization. Present only on enhanced monitoring series
     */
    metric_group: string;

    /**
     * Hourly average, one entry per timestamp, null where the hour has no data. Absent when the metric does not store it
     */
    average: Array<number>;

    /**
     * Hourly minimum, one entry per timestamp, null where the hour has no data. Absent when the metric does not store it
     */
    minimum: Array<number>;

    /**
     * Hourly maximum, one entry per timestamp, null where the hour has no data. Absent when the metric does not store it
     */
    maximum: Array<number>;

    /**
     * Hourly sum (AWS Sum, Azure total), one entry per timestamp, null where the hour has no data. Absent when the metric does not store it
     */
    sum: Array<number>;

    /**
     * Hourly sample count (AWS SampleCount, Azure count), one entry per timestamp, null where the hour has no data. Absent when the metric does not store it
     */
    count: Array<number>;

}
